const {
  GEAR_LONGBOW,
  GEAR_SHORTBOW,
} = require('./../../gearIdList')

const bowsDescription = `[Короткие](GEAR:${GEAR_SHORTBOW}) и [длинные луки](GEAR:${GEAR_LONGBOW}) используют натяжение тетивы рукой, чтобы посылать стрелу к цели. Короткие луки высотой около трёх футов и могут стрелять в среднем на восемьдесят футов. Длинные луки на пару футов выше и обычно могут стрелять примерно на сто пятьдесят футов, но их не так легко носить с собой. Все луки требуют определенной силы для эффективного использования.`

module.exports = bowsDescription
